import {
    GET_ALL_BUSINESS_AREA_DATA_SUCCESS,
    GET_ALL_BUSINESS_AREA_DATA_FAILURE,
    CREATE_BUSINESS_AREA_DATA_SUCCESS,
    CREATE_BUSINESS_AREA_DATA_FAILURE,
    GET_BUSINESS_AREA_DATA_BY_ID_SUCCESS,
    GET_BUSINESS_AREA_DATA_BY_ID_FAILURE,
    DELETE_BUSINESS_AREA_DATA_SUCCESS,
    DELETE_BUSINESS_AREA_DATA_FAILURE,
    UPDATE_BUSINESS_AREA_DATA_SUCCESS,
    UPDATE_BUSINESS_AREA_DATA_FAILURE,
    FETCH_BUSINESS_AREA_DOMAIN_DATA_REQUEST,
    FETCH_BUSINESS_AREA_DOMAIN_DATA_SUCCESS,
    FETCH_BUSINESS_AREA_DOMAIN_DATA_FAILURE,
    GET_USER_BUSINESS_AREA_DATA_PERMISSION_SUCCESS,
    GET_USER_BUSINESS_AREA_DATA_PERMISSION_FAILURE,
    CREATE_BULK_UPLOAD_DOMAIN_DATA_JOB_SUCCESS,
    CREATE_BULK_UPLOAD_DOMAIN_DATA_JOB_FAILURE,
    CREATE_DOMAIN_DATA_REQUEST,
    CREATE_DOMAIN_DATA_SUCCESS,
    CREATE_DOMAIN_DATA_FAILURE,
    UPDATE_DOMAIN_DATA_REQUEST,
    UPDATE_DOMAIN_DATA_SUCCESS,
    UPDATE_DOMAIN_DATA_FAILURE,
    DELETE_DOMAIN_DATA_REQUEST,
    DELETE_DOMAIN_DATA_SUCCESS,
    DELETE_DOMAIN_DATA_FAILURE,
} from "./actions";

const initialState = {
    getAllBusinessAreaDataResult: {
        success: true,
    },
    dataDomainsResult: {
        Items: [],
    },
    createBusinessAreaDataResult: {
        success: true,
    },
    getBusinessAreaDataByIdResult: {
        success: true,
    },
    businessAreaData: null,
    deleteBusinessAreaDataResult: {
        success: true,
    },
    updateBusinessAreaDataResult: {
        success: true,
    },
    businessAreaDomainDataResult: {},
    getUserBusinessAreaDataPermissionResult: {
        success: true,
    },
    permission: null,
    createBulkUploadDomainDataJobResult: {
        success: true,
    },
    domainDataMutationResult: {
        success: true,
        inProgress: false,
    },
};

export default (state = initialState, action) => {
    let dataDomainsResult = {
        Items: [],
    };
    let domainDataResult = {
        Items: [],
    };
    switch (action.type) {
        case GET_ALL_BUSINESS_AREA_DATA_SUCCESS:
            dataDomainsResult = action.payload;
            return { ...state, getAllBusinessAreaDataResult: { success: true }, dataDomainsResult };
        case GET_ALL_BUSINESS_AREA_DATA_FAILURE:
            return {
                ...state,
                getAllBusinessAreaDataResult: { success: false, ...action.payload },
                dataDomainsResult: {
                    Items: [],
                },
            };
        case CREATE_BUSINESS_AREA_DATA_SUCCESS:
            return { ...state, createBusinessAreaDataResult: { success: true, businessAreaData: action.payload } };
        case CREATE_BUSINESS_AREA_DATA_FAILURE:
            return { ...state, createBusinessAreaDataResult: { success: false, ...action.payload } };
        case GET_BUSINESS_AREA_DATA_BY_ID_SUCCESS:
            return { ...state, getBusinessAreaDataByIdResult: { success: true }, businessAreaData: action.payload };
        case GET_BUSINESS_AREA_DATA_BY_ID_FAILURE:
            return { ...state, getBusinessAreaDataByIdResult: { success: false, ...action.payload }, businessAreaData: null };
        case DELETE_BUSINESS_AREA_DATA_SUCCESS:
            dataDomainsResult = { ...dataDomainsResult };
            dataDomainsResult.Items = state.dataDomainsResult.Items.filter((dataDomain) => dataDomain.dataDomainId !== action.payload.dataDomainId);
            return { ...state, deleteBusinessAreaDataResult: { success: true }, dataDomainsResult };
        case DELETE_BUSINESS_AREA_DATA_FAILURE:
            return { ...state, deleteBusinessAreaDataResult: { success: false, ...action.payload } };
        case UPDATE_BUSINESS_AREA_DATA_SUCCESS:
            return { ...state, updateBusinessAreaDataResult: { success: true } };
        case UPDATE_BUSINESS_AREA_DATA_FAILURE:
            return { ...state, updateBusinessAreaDataResult: { success: false, ...action.payload } };
        case FETCH_BUSINESS_AREA_DOMAIN_DATA_REQUEST:
            return {
                ...state,
                businessAreaDomainDataResult: {
                    ...state.businessAreaDomainDataResult,
                    [action.params.dataDomainId]: {
                        inProgress: true,
                        domainDataResult: !action.params.pageKey
                            ? { Items: [] }
                            : (state.businessAreaDomainDataResult[action.params.dataDomainId]?.domainDataResult ?? { Items: [] }),
                        error: null,
                    },
                },
            };
        case FETCH_BUSINESS_AREA_DOMAIN_DATA_SUCCESS:
            domainDataResult = action.payload.domainDataResult;
            {
                const currentItems = state.businessAreaDomainDataResult[action.payload.dataDomainId]?.domainDataResult?.Items ?? [];
                const currentIds = new Set(currentItems.map((item) => item.domainDataId).filter((domainDataId) => domainDataId != null));
                const newItems = domainDataResult.Items.filter((item) => item.domainDataId == null || !currentIds.has(item.domainDataId));
                domainDataResult = {
                    ...domainDataResult,
                    Items: currentItems.concat(newItems).map((item, index) => ({ ...item, sNo: index + 1 })),
                };
            }
            return {
                ...state,
                businessAreaDomainDataResult: {
                    ...state.businessAreaDomainDataResult,
                    [action.payload.dataDomainId]: {
                        inProgress: false,
                        domainDataResult,
                        error: null,
                    },
                },
            };
        case FETCH_BUSINESS_AREA_DOMAIN_DATA_FAILURE:
            return {
                ...state,
                businessAreaDomainDataResult: {
                    ...state.businessAreaDomainDataResult,
                    [action.payload.dataDomainId]: {
                        inProgress: false,
                        domainDataResult: { Items: [] },
                        error: action.payload.error,
                    },
                },
            };
        case GET_USER_BUSINESS_AREA_DATA_PERMISSION_SUCCESS:
            return { ...state, getUserBusinessAreaDataPermissionResult: { success: true }, permission: action.payload };
        case GET_USER_BUSINESS_AREA_DATA_PERMISSION_FAILURE:
            return { ...state, getUserBusinessAreaDataPermissionResult: { success: false, ...action.payload }, permission: null };
        case CREATE_BULK_UPLOAD_DOMAIN_DATA_JOB_SUCCESS:
            return { ...state, createBulkUploadDomainDataJobResult: { success: true } };
        case CREATE_BULK_UPLOAD_DOMAIN_DATA_JOB_FAILURE:
            return { ...state, createBulkUploadDomainDataJobResult: { success: false, ...action.payload } };
        case CREATE_DOMAIN_DATA_REQUEST:
            if (state.domainDataMutationResult.inProgress) {
                return state;
            }
            return {
                ...state,
                domainDataMutationResult: {
                    inProgress: true,
                    operation: "create",
                    dataDomainId: action.params.dataDomainId,
                    submittedValues: action.params.domainData,
                },
            };
        case CREATE_DOMAIN_DATA_SUCCESS: {
            const currentResult = state.businessAreaDomainDataResult[action.payload.dataDomainId]?.domainDataResult ?? { Items: [] };
            const createdRecord = action.payload.domainData;
            const existingIndex =
                createdRecord.domainDataId != null ? currentResult.Items.findIndex((item) => item.domainDataId === createdRecord.domainDataId) : -1;
            const isNewRecord = existingIndex === -1;
            const nextItems = isNewRecord
                ? currentResult.Items.concat({ ...createdRecord, sNo: currentResult.Items.length + 1 })
                : currentResult.Items.map((item, index) => (index === existingIndex ? { ...item, ...createdRecord } : item));
            return {
                ...state,
                businessAreaData:
                    isNewRecord && state.businessAreaData?.dataDomainId === action.payload.dataDomainId
                        ? { ...state.businessAreaData, recordCount: (state.businessAreaData.recordCount || 0) + 1 }
                        : state.businessAreaData,
                businessAreaDomainDataResult: {
                    ...state.businessAreaDomainDataResult,
                    [action.payload.dataDomainId]: {
                        ...state.businessAreaDomainDataResult[action.payload.dataDomainId],
                        domainDataResult: { ...currentResult, Items: nextItems },
                    },
                },
                domainDataMutationResult: { ...state.domainDataMutationResult, success: true, inProgress: false, confirmedRecord: action.payload.domainData },
            };
        }
        case CREATE_DOMAIN_DATA_FAILURE:
            return { ...state, domainDataMutationResult: { ...state.domainDataMutationResult, success: false, inProgress: false, ...action.payload.error } };
        case UPDATE_DOMAIN_DATA_REQUEST:
            if (state.domainDataMutationResult.inProgress) {
                return state;
            }
            return {
                ...state,
                domainDataMutationResult: {
                    inProgress: true,
                    operation: "update",
                    dataDomainId: action.params.dataDomainId,
                    record: action.params.currentDomainData,
                    recordId: action.params.currentDomainData.domainDataId,
                    submittedValues: action.params.updatedDomainData,
                },
            };
        case UPDATE_DOMAIN_DATA_SUCCESS: {
            const currentResult = state.businessAreaDomainDataResult[action.payload.dataDomainId]?.domainDataResult ?? { Items: [] };
            return {
                ...state,
                businessAreaDomainDataResult: {
                    ...state.businessAreaDomainDataResult,
                    [action.payload.dataDomainId]: {
                        ...state.businessAreaDomainDataResult[action.payload.dataDomainId],
                        domainDataResult: {
                            ...currentResult,
                            Items: currentResult.Items.map((item) =>
                                item.domainDataId === action.payload.domainData.domainDataId ? { ...item, ...action.payload.domainData } : item,
                            ),
                        },
                    },
                },
                domainDataMutationResult: { ...state.domainDataMutationResult, success: true, inProgress: false, confirmedRecord: action.payload.domainData },
            };
        }
        case UPDATE_DOMAIN_DATA_FAILURE:
            return { ...state, domainDataMutationResult: { ...state.domainDataMutationResult, success: false, inProgress: false, ...action.payload.error } };
        case DELETE_DOMAIN_DATA_REQUEST:
            if (state.domainDataMutationResult.inProgress) {
                return state;
            }
            return {
                ...state,
                domainDataMutationResult: {
                    inProgress: true,
                    operation: "delete",
                    dataDomainId: action.params.dataDomainId,
                    record: action.params.domainData,
                    recordId: action.params.domainData.domainDataId,
                },
            };
        case DELETE_DOMAIN_DATA_SUCCESS: {
            const currentResult = state.businessAreaDomainDataResult[action.payload.dataDomainId]?.domainDataResult ?? { Items: [] };
            const remainingItems = currentResult.Items.filter((item) => item.domainDataId !== action.payload.domainDataId).map((item, index) => ({ ...item, sNo: index + 1 }));
            return {
                ...state,
                businessAreaData: state.businessAreaData?.dataDomainId === action.payload.dataDomainId
                    ? { ...state.businessAreaData, recordCount: Math.max(0, (state.businessAreaData.recordCount || 0) - 1) }
                    : state.businessAreaData,
                businessAreaDomainDataResult: {
                    ...state.businessAreaDomainDataResult,
                    [action.payload.dataDomainId]: {
                        ...state.businessAreaDomainDataResult[action.payload.dataDomainId],
                        domainDataResult: { ...currentResult, Items: remainingItems },
                    },
                },
                domainDataMutationResult: { ...state.domainDataMutationResult, success: true, inProgress: false },
            };
        }
        case DELETE_DOMAIN_DATA_FAILURE:
            return { ...state, domainDataMutationResult: { ...state.domainDataMutationResult, success: false, inProgress: false, ...action.payload.error } };
        default:
            return state;
    }
};
